import React from "react";
import { useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Blogs from "./Blogs";

const navigation = [
  { name: "Product", href: "#" },
  { name: "Features", href: "#" },
  { name: "Resources", href: "#" },
  { name: "Company", href: "#" },
];
const stats = [
  { label: "Students Enrolled", value: "Over 150,000 " },
  { label: "Complete Their Courses", value: "95% of Students " },
  { label: "Now Working in IT Jobs", value: "10,000+ Students " },
];
const values = [
  {
    name: "✅ Student-Focused Learning ",
    description:
      "Our courses are made to be practical and easy to follow, so every learner can understand and apply what they learn.",
  },
  {
    name: "✅ Modern and Updated Teaching",
    description:
      "We always use the latest teaching methods and updated content so you can stay ahead in the IT industry.",
  },
  {
    name: "✅ Education for Everyone",
    description:
      "Learning should be easy, affordable, and available to all. We offer flexible study options to fit different schedules and budgets.",
  },
  {
    name: "✅ Learning by Doing",
    description:
      "Understanding theory is important, but practicing what you learn is even better. Our courses include real projects, case studies, and hands-on activities.",
  },
  {
    name: "✅ Job-Ready Training",
    description:
      "Our courses help you get the skills employers want, so you can find real IT jobs faster.",
  },
  {
    name: "✅ Always Improving",
    description:
      "We regularly update our courses to keep up with the latest trends in the industry. This ensures you always learn the newest tools and technologies.  ",
  },
];
const team = [
  {
    name: "Parth Panchal",
    role: "Manager / AI Engineer",
    imageUrl: "/teams/parth.JPG",
    alt: "parth",
  },
  {
    name: "Mohammad Aasif",
    role: "Software Engineer SDE II",
    imageUrl: "/teams/mohammad.jpeg",
    alt: "mohammad",
  },
  {
    name: "Satish Thakur",
    role: "Frontend Expert",
    imageUrl: "/teams/satish-thakur.jpg",
    alt: "staish thakur",
  },
  {
    name: "Manoj ",
    role: "Backend Expert",
    imageUrl: "/teams/manoj-talwar.jpg",
    alt: "manoj kumar",
  },

  // More people...
];
const blogPosts = [
  {
    id: 1,
    title: "Vel expedita assumenda placeat aut nisi optio voluptates quas",
    href: "#",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    imageUrl:
      "https://media.istockphoto.com/id/1371339413/photo/co-working-team-meeting-concept-businessman-using-smart-phone-and-digital-tablet-and-laptop.jpg?s=612x612&w=0&k=20&c=ysEsVw3q2axYt3oVZAuQjtHRlN3lY-U_e0ikK5yKIXQ=",
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
    alt: "expedita assumenda",
    author: {
      name: "Michael Foster",
      alt: "Michael Foster",
      imageUrl:
        "https://i.pinimg.com/474x/68/06/24/680624236bf7c6d77afc034674244be7.jpg",
    },
  },
  {
    id: 1,
    title: "Vel expedita assumenda placeat aut nisi optio voluptates quas",
    href: "#",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    imageUrl:
      "https://www.skillreactor.io/blog/wp-content/uploads/2024/05/Full-Stack-Developer.jpg",
    date: "Mar 16, 2020",
    alt: "voluptates",
    datetime: "2020-03-16",
    author: {
      name: "Michael Foster",
      alt: "Michael",
      imageUrl:
        "https://i.pinimg.com/236x/81/8f/1b/818f1b3ee137f5891a952ce42744161f.jpg",
    },
  },
  {
    id: 1,
    title: "Vel expedita assumenda placeat aut nisi optio voluptates quas",
    href: "#",
    alt: "voluptas",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    imageUrl:
      "https://media.istockphoto.com/id/1452604857/photo/businessman-touching-the-brain-working-of-artificial-intelligence-automation-predictive.jpg?s=612x612&w=0&k=20&c=GkAOxzduJbUKpS2-LX_l6jSKtyhdKlnPMo2ito4xpR4=",
    date: "Mar 16, 2020",
    datetime: "2020-03-16",
    author: {
      name: "Michael Foster",
      alt: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  },
  // More posts...
];

const OurMission = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="bg-white">
      <main className="isolate">
        {/* Hero section */}
        <div className="relative isolate -z-10">
          <svg
            aria-hidden="true"
            className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
          >
            <defs>
              <pattern
                x="50%"
                y={-1}
                id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                width={200}
                height={200}
                patternUnits="userSpaceOnUse"
              >
                <path d="M.5 200V.5H200" fill="none" />
              </pattern>
            </defs>
            <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
              <path
                d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
                strokeWidth={0}
              />
            </svg>
            <rect
              fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)"
              width="100%"
              height="100%"
              strokeWidth={0}
            />
          </svg>
          <div
            aria-hidden="true"
            className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
          >
            <div
              style={{
                clipPath:
                  "polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)",
              }}
              className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
            />
          </div>
        </div>
        {/* Content section */}
        {/* <div className="mx-auto  max-w-7xl px-6 sm:mt-0 lg:px-8 ">
          <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Get the IT Skills You Need to Succeed
            </h2>
            <div className="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row">
              <div className="lg:w-full lg:max-w-2xl lg:flex-auto">
                <p className="ext-base leading-8 text-gray-600">
                  At BrainboxStudy, we love helping people like you reach their
                  IT goals. Technology is always changing, and there's a big
                  need for skilled IT workers. That's why we offer a wide range
                  of IT courses to give you the knowledge and skills you need to
                  succeed. Our courses are designed to be easy to understand and
                  practical.
                </p>
                <div className="mt-5 max-w-xl text-base leading-7 text-gray-700">
                  <p>
                    We aim to connect theory with practice by providing
                    high-quality, relevant IT education. We believe everyone
                    should have the chance to learn and grow in the tech world.
                    We strive to make our courses accessible and beneficial for
                    all learners.
                  </p>
                  <p className="mt-5">
                    We focus on the learner, offering interactive learning
                    experiences for different learning styles. Our courses are
                    created and taught by experienced IT professionals who are
                    eager to share their knowledge. We ensure our teaching
                    methods are engaging and effective.
                  </p>
                </div>
              </div>
              <div className="lg:flex lg:flex-auto lg:justify-center">
                <dl className="w-64 space-y-8 xl:w-80">
                  {stats.map((stat) => (
                    <div
                      key={stat.label}
                      className="flex flex-col-reverse gap-y-4"
                    >
                      <dt className="text-base leading-7 text-gray-600">
                        {stat.label}
                      </dt>
                      <dd className="text-5xl font-semibold tracking-tight text-gray-900">
                        {stat.value}
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </div> */}
        {/* Image section */}
        {/* <div className="mt-16 sm:mt-16 xl:mx-auto xl:max-w-7xl xl:px-8">
          <img
            alt="unsplash"
            src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80"
            className="aspect-[5/2] w-full object-cover xl:rounded-3xl"
          />
        </div> */}
        {/* Values section */}
        <div className="mx-auto mt-4 max-w-7xl px-6 sm:mt-6 lg:px-8">
          <div className="lg:mx-auto lg:max-w-4xl text-justify lg:text-center ">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900  sm:text-4xl">
              Our Values
            </h2>
            <p className=" text-base sm:text-lg mb-8 mx-auto lg:px-16  text-gray-700">
            At Brain Box Study, we believe that good education can change lives and careers.
             Our core values shape everything we do:
            </p>
          </div>
          <dl className=" grid grid-cols-1 gap-x-8 sm:space-y-4 lg:space-y-2 text-base leading-6 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {values.map((value) => (
              <div key={value.name}>
                <dt className=" text-gray-900 text-base font-semibold">
                  {value.name}
                </dt>
                <dd className=" text-gray-600  text-sm lg:text-base text-justify">
                  {value.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
        {/* Logo cloud */}
        <div className="relative isolate -z-10 mt-5 sm:mt-5">
          <div className="absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 justify-center overflow-hidden [mask-image:radial-gradient(50%_45%_at_50%_55%,white,transparent)]">
            <svg
              aria-hidden="true"
              className="h-[40rem] w-[80rem] flex-none stroke-gray-200"
            >
              <defs>
                <pattern
                  x="50%"
                  y="50%"
                  id="e9033f3e-f665-41a6-84ef-756f6778e6fe"
                  width={200}
                  height={200}
                  patternUnits="userSpaceOnUse"
                  patternTransform="translate(-100 0)"
                >
                  <path d="M.5 200V.5H200" fill="none" />
                </pattern>
              </defs>
              <svg x="50%" y="50%" className="overflow-visible fill-gray-50">
                <path
                  d="M-300 0h201v201h-201Z M300 200h201v201h-201Z"
                  strokeWidth={0}
                />
              </svg>
              <rect
                fill="url(#e9033f3e-f665-41a6-84ef-756f6778e6fe)"
                width="100%"
                height="100%"
                strokeWidth={0}
              />
            </svg>
          </div>
        </div>
        <div className="">
          <div className="h-60 w-full bg-gray-900"></div>

          <div className="max-w-7xl max-md:max-w-xl max-sm:max-w-sm mx-auto -mt-48 px-6">
            <h2 className="text-2xl md:text-4xl text-center font-bold text-white mb-12">
              {" "}
              Our Professional Team
            </h2>

            <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6 max-sm:justify-center text-center">
              {team.map((person) => (
                <div
                  key={person.name}
                  className="bg-white rounded-sm p-6 shadow-md hover:scale-105 transition-all duration-500"
                >
                  <div className="">
                    {/* <img src={member.image} alt={member.name} className="w-full rounded-lg inline-block" /> */}
                    <img
                      alt={person.alt}
                      src={person.imageUrl}
                      className="mx-auto "
                    />
                  </div>

                  <div className="mt-6">
                    <h4 className="text-gray-800 text-lg font-bold">
                      {" "}
                      {person.name}
                    </h4>
                    <p className="text-sm text-gray-600 mt-1">{person.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="bg-white py-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-7">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold text-gray-800 inline-block relative after:absolute after:w-4/6 after:h-1 after:left-0 after:right-0 after:-bottom-4 after:mx-auto after:bg-amber-600 after:rounded-lg-full">
                LATEST BLOGS
              </h2>
            </div>
            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 max-lg:max-w-3xl max-md:max-w-md mx-auto">
              {blogPosts.map((post) => (
                <div
                  key={post.id}
                  className="bg-white cursor-pointer rounded-lg overflow-hidden shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)] relative group"
                >
                  <img
                    alt={post.alt}
                    src={post.imageUrl}
                    className="w-full h-96 object-cover"
                  />
                  <div className="p-6 absolute bottom-0 left-0 right-0 bg-gray-200 opacity-90">
                    <span className="text-sm block text-gray-800 mb-2">
                      {post.datetime} | {post.date}
                    </span>
                    <h3 className="text-base font-bold text-gray-800">
                    {post.title}
                    </h3>
                    <div className="h-0 overflow-hidden group-hover:h-10 group-hover:mt-2 transition-all duration-300">
                      <p className="text-gray-800 text-sm">
                      {post.title}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}
             <Blogs />
          </div>
        </div>
      </main>
    </div>
  );
};

export default OurMission;
